export const THEME_ENUM = {
    DARK: "0",
    LIGHT: "1",
    AUTO: "2"
}
export const DEFAULT_THEME = THEME_ENUM.AUTO